export const validatePassword = (rule, value, callback) => {
  let regPass = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$/;
  if (!regPass.test(value) && value) {
    callback(
      "Must be at least 8 characters long and include upper and lowercase letters and at least one number !"
    );
  } else {
    callback();
  }
};
